import { render, staticRenderFns } from "./creditStatistics.vue?vue&type=template&id=6a5d22ce&scoped=true&"
import script from "./creditStatistics.vue?vue&type=script&lang=js&"
export * from "./creditStatistics.vue?vue&type=script&lang=js&"
import style0 from "./creditStatistics.vue?vue&type=style&index=0&id=6a5d22ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d22ce",
  null
  
)

export default component.exports